import { put } from "redux-saga/effects"
import * as actionTypes from "../actionTypes";

export default function* postingDeleted(action: actionTypes.PostingDeleted) {
    yield put({ type: actionTypes.REDUCE_POSTING_DELETED, payload: action.payload });
}
